<form
  name="form"
  [formGroup]="form"
  autocomplete="off"
  fxLayout="column"
  fxLayoutAlign="space-between center"
>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Provincia</mat-label>
    <mat-select
      formControlName="province"
      (selectionChange)="provinceSelect($event)"
    >
      <mat-option *ngFor="let province of provinces" [value]="province.id">
        {{ province.name }}
      </mat-option>
    </mat-select>
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.province"
      [ngClass]="{ 'error-icon': controlHasError('province') }"
      >location_city</mat-icon
    >
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Ubicación</mat-label>
    <mat-select formControlName="canton">
      <mat-option *ngFor="let canton of cantons" [value]="canton.id">
        {{ canton.name }}
      </mat-option>
    </mat-select>
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.canton"
      [ngClass]="{ 'error-icon': controlHasError('canton') }"
      >map</mat-icon
    >
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Calle</mat-label>
    <input matInput formControlName="street" />
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.street"
      [ngClass]="{ 'error-icon': controlHasError('street') }"
      >streetview</mat-icon
    >
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>N° Calle</mat-label>
    <input matInput formControlName="streetNumber" numbersOnly />
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.streetNumber"
      [ngClass]="{ 'error-icon': controlHasError('streetNumber') }"
      >confirmation_number</mat-icon
    >
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Intersección</mat-label>
    <input matInput formControlName="intersection" />
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.intersection"
      [ngClass]="{ 'error-icon': controlHasError('intersection') }"
      >device_hub</mat-icon
    >
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Nombre Local</mat-label>
    <input matInput formControlName="storeName" />
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.storeName"
      [ngClass]="{ 'error-icon': controlHasError('storeName') }"
      >store</mat-icon
    >
  </mat-form-field>
</form>
